import { API_MAIN_VERSION, BASE_URL } from "@/config/constantes";
import { EMethod, IFactoryFunctionRequest, paginate } from "@bc-library/interface";
import { AxiosInstance } from "axios";
import useAxios from "../api/useAxios";

const resource = 'employeeVariables'

const getOne = (axios: IFactoryFunctionRequest<any, any>) => (employeeVariablesId: string) => {
  return axios({
    method: EMethod.get,
    url: `${BASE_URL}/${API_MAIN_VERSION}/${resource}/v2/${employeeVariablesId}`,
  })
}

const filter = (axios: IFactoryFunctionRequest<paginate<{ display: string }>, any>) => (query: { page: number; limit: number; search?: string }) => {
  return axios({
    method: EMethod.get,
    url: `${BASE_URL}/${API_MAIN_VERSION}/${resource}/v2/filter`,
    query,
  })
}

const updateEmployeeVariablesCategory = (axios: IFactoryFunctionRequest<any, any>) => (id, { data }) => {
  return axios({
    method: EMethod.patch,
    url: `${BASE_URL}/${API_MAIN_VERSION}/${resource}/v2/update/${id}`,
    data,
  })
}

const createEmployeeVariablesCategory = (axios: IFactoryFunctionRequest<any, any>) => (data) => {
  return axios({
    method: EMethod.post,
    url: `${BASE_URL}/${API_MAIN_VERSION}/${resource}/v2/create`,
    data,
  })
}

const deleteEmployeeVariablesCategory = (axios: IFactoryFunctionRequest<any, any>) => (id: string) => {
  return axios({
    method: EMethod.delete,
    url: `${BASE_URL}/${API_MAIN_VERSION}/${resource}/v2/delete/${id}`,
  })
}

export default (axios: AxiosInstance) => ({
  getOne: getOne(useAxios(axios)),
  filter: filter(useAxios(axios)),
  update: updateEmployeeVariablesCategory(useAxios(axios)),
  create: createEmployeeVariablesCategory(useAxios(axios)),
  delete: deleteEmployeeVariablesCategory(useAxios(axios))
})
